export default __webpack_public_path__ + "static/media/richies-flower.51ef9be7.jpg";